module.exports = __webpack_public_path__ + "img/avatar-human-male-profile-user-icon-518358.be94e54e.png";